import styled from 'styled-components'
import PropTypes from 'prop-types'

const gridArea = 'sdb'
const Aside = styled.aside`
  grid-area: ${gridArea};
  background-color: ${({ bgColor }) => bgColor};
`
const Sidebar = ({ children, bgColor = 'white', ...rest }) => {
  return (
    <Aside bgColor={bgColor} {...rest}>
      {children}
    </Aside>
  )
}

Sidebar.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}
Sidebar.slotName = 'PageSidebar'

export { Sidebar, gridArea }
